import { TABLET_BREAKPOINT } from "@/constants/layout";
import { useEffect, useState } from "react";
import { Platform, useWindowDimensions } from "react-native";

/** Native und schmale oder grobe Zeiger: 44 px. Web-Desktop mit feinem Zeiger: dicht. */
export function coarseTargetFor(width: number, os: string, pointerCoarse: boolean): boolean {
  if (os !== "web") return true;
  if (width < TABLET_BREAKPOINT) return true;
  return pointerCoarse;
}

function readCoarse(width: number): boolean {
  const pointerCoarse =
    typeof window !== "undefined" &&
    typeof window.matchMedia === "function" &&
    window.matchMedia("(pointer: coarse)").matches;
  return coarseTargetFor(width, Platform.OS, pointerCoarse);
}

/** 44-px-Ziel auf Native, unter dem Tablet-Breakpoint und bei grobem Zeiger. */
export function useCoarseTarget(): boolean {
  const { width } = useWindowDimensions();
  const [coarse, setCoarse] = useState(() => readCoarse(width));
  useEffect(() => {
    const apply = () => setCoarse(readCoarse(width));
    apply();
    if (Platform.OS !== "web" || typeof window === "undefined" || typeof window.matchMedia !== "function") {
      return;
    }
    const query = window.matchMedia("(pointer: coarse)");
    query.addEventListener?.("change", apply);
    return () => query.removeEventListener?.("change", apply);
  }, [width]);
  return coarse;
}
